import React, { FunctionComponent } from 'react';

// components
import ColorPicker from './ColorPicker';

interface OwnProps {
  displayModalBtnColorPicker: boolean;
  paywall_buttons_bg_color: string;
  handleClick: (displayPicker: string) => any;
  handleClose: (displayPicker: string) => any;
  handlePickerChange: (elementName: string) => any;
}

const PaywallModalButtonConfigurationContent: FunctionComponent<OwnProps> = ({
  displayModalBtnColorPicker,
  paywall_buttons_bg_color,
  handleClick,
  handleClose,
  handlePickerChange,
}) => {
  return (
    <>
      <ColorPicker
        tag="button_color_picker"
        showColorPicker={displayModalBtnColorPicker}
        displayPicker="displayModalBtnColorPicker"
        element_name="paywall_buttons_bg_color"
        background_color={paywall_buttons_bg_color}
        text="Button color"
        handleClick={handleClick('displayModalBtnColorPicker')}
        handleClose={handleClose('displayModalBtnColorPicker')}
        handlePickerChange={handlePickerChange('paywall_buttons_bg_color')}
      />
    </>
  );
};

export default PaywallModalButtonConfigurationContent;
